var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 13.333H15V26.6663H18.3333V13.333Z",
    fill: "#121216"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 13.333H21.6665V26.6663H24.9998V13.333Z",
    fill: "#121216"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePause);
export default __webpack_public_path__ + "static/media/circlePause.a78665e0507933944665ca10d6bef1f1.svg";
export { ForwardRef as ReactComponent };